// @flow
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import CollapsibleButton from '../CollapsibleButton/CollapsibleButton';
import Tooltip from '../Tooltip/Tooltip';

import style from './Summary.scss';

import type { Node } from 'react';

type SummaryProps = {
  titleIntl: string;
  subtitleIntl?: string;
  subtitleExtra?: string;
  children?: Node;
  disabled?: boolean;
  initialOpen?: boolean;
};

type SummaryRowProps = {
  labelIntl: string;
  labelNoColon?: boolean;
  labelExtra?: string;
  content: string;
  hintIntl?: string;
  color?: 'green' | 'lightBlue' | 'black';
  bold?: boolean;
  noTopPadding?: boolean;
};

export const SummaryRule = () => <div className={style.summaryHrWrap}><hr className={style.summaryHr}/></div>;

export const SummaryRow = (props: SummaryRowProps) => {
  const { labelIntl, labelNoColon, labelExtra, content, hintIntl, color, bold, noTopPadding } = props;
  const toolTip = !!hintIntl && <Tooltip id={hintIntl}
                                         intl={hintIntl}/>;
  const spanClassNames = classNames({
    [style.green]: color === 'green',
    [style.lightBlue]: color === 'lightBlue',
    [style.black]: color === 'black',
    [style.bold]: !!bold,
  });
  return <div className={classNames(style.summaryRowWrap, {[style.noTopPadding]: noTopPadding})}>
    <FormattedMessage id={labelIntl}>{
      txt => <span className={spanClassNames}>{txt}{!!labelNoColon ? '' : ':'} {labelExtra} {toolTip}</span>
    }</FormattedMessage>
    <span className={classNames(style.spanContent, spanClassNames)}>{content}</span>
  </div>
};

const Summary = (props: SummaryProps) => <CollapsibleButton titleIntl={props.titleIntl}
                                                            subtitleIntl={props.subtitleIntl}
                                                            disabled={props.disabled}
                                                            initialOpen={props.initialOpen}
                                                            subtitleExtra={props.subtitleExtra}>
  <Fragment>
    {props.children}
  </Fragment>
</CollapsibleButton>;

Summary.propTypes = {
  titleIntl: PropTypes.string.isRequired,
  subtitleIntl: PropTypes.string,
  subtitleExtra: PropTypes.string,
  labelNoColon: PropTypes.string,
  labelExtra: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  initialOpen: PropTypes.bool,
};

SummaryRow.propTypes = {
  labelIntl: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  hintIntl: PropTypes.string,
  color: PropTypes.string,
  bold: PropTypes.bool,
  noTopPadding: PropTypes.bool,
};

export default Summary;



// WEBPACK FOOTER //
// ./src/elements/Summary/Summary.jsx